export default {
  now: new Date(),
  version: 'v0.48.1',
  lastVersion: '',
  serverVersion: '',
  language: 'de_DE',
  confirmPrivacyPolicy: false
}



// WEBPACK FOOTER //
// ./src/store/state.js